import template from './campaignMonitorAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              this.clientId = '';
              this.clientEmail = '';
              this.token = '';
              this.integrator = '';
              this.confirm = () => {
                $mdDialog.hide({
                  clientId: this.clientId,
                  clientEmail: this.clientEmail,
                  token: this.token,
                  integrator: this.integrator
                });
              };
              this.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
